import React, { useState } from "react";
import { Link } from "react-router-dom";
import { NavLink } from "react-router-dom";
import "./Navbar.css";
import Hamburger from "../images/icons/hamburger.png";

function Navbar() {
  const [click, setClick] = useState(false);

  const handleClick = () => setClick(!click);
  const closeMobileMenu = () => setClick(false);

  return (
    <div>
      <nav className="navbar">
        <div className="navbar-container">
          <div className="menu-icon" onClick={handleClick}>
            <img
              src={Hamburger}
              style={{ height: "20px" }}
              alt="Hamburger Menu"
            ></img>
            <i className={click ? "fas fa-times" : "fas fa-bars"}></i>
          </div>
          <Link to="/" className="navbar-logo" style={{ fontWeight: 500 }}>
            Linnea Olsson <i className="fab.fa-typo3" />
          </Link>

          <ul className={click ? "nav-menu active" : "nav-menu"}>
            <li className="nav-item">
              <NavLink
                to="/"
                className={({ isActive }) =>
                  "nav-links active" + (isActive ? " activated" : "")
                }
                onClick={closeMobileMenu}
                style={{ fontWeight: 500 }}
              >
                Projects
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                to="/about"
                className={({ isActive }) =>
                  "nav-links active" + (isActive ? " activated" : "")
                }
                onClick={closeMobileMenu}
                style={{ fontWeight: 500 }}
              >
                About
              </NavLink>
            </li>
          </ul>
        </div>
      </nav>
    </div>
  );
}

export default Navbar;
